import RFIInfantFruitsAndVegsProduct from 'models/RFIInfantFruitsAndVegsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import RFIInfantFruitsAndVegsPackage from './RFIInfantFruitsAndVegsPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { getRFIInfantFruitsVegsCategories } from './Utiliites'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc
      initialBrandNameOptions={[
        { label: 'Brand Name', value: '', isDisabled: true },
      ]}
      updateBrandNameOptions={getRFIInfantFruitsVegsCategories}
    />
  ),
  packagingInfo: <RFIInfantFruitsAndVegsPackage />,
  productTitle: '2025 RFI Brand Specific Infant Fruits and Vegetables',
  model: RFIInfantFruitsAndVegsProduct,
  validCategories: ['12'],
  validSubCategories: [
    '001RFI',
    '002RFI',
    '003RFI',
    '101RFI',
    '102RFI',
    '103RFI',
  ],
}

const RFIInfantFruitsAndVegs = () => <ProductForm product={productOptions} />

export default RFIInfantFruitsAndVegs
